// extracted by mini-css-extract-plugin
export default {"currensy_box":"CurrencyBox_currensy_box__ujLV4","currensy_symbol":"CurrencyBox_currensy_symbol__YZ+dw"};